'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _Quiz = require('../vue/components/Quiz');

var _Quiz2 = _interopRequireDefault(_Quiz);

var _store = require('../vue/store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DoshaQuiz = function DoshaQuiz(el) {
  (0, _classCallCheck3.default)(this, DoshaQuiz);

  window.setTimeout(function () {
    new _vue2.default({
      store: _store2.default,
      components: {
        quiz: _Quiz2.default
      }
    }).$mount(el);
  }, 0);
};

exports.default = DoshaQuiz;